export default __webpack_public_path__ + "static/media/IconCashOut.8547bd0c.svg";